import { useState } from "react";
import useQueryParam from "./useQueryParam";

export type PaginationData = {
  page: number;
  per: number;
  setPage?: (number) => void;
  setPer?: (number) => void;
  next?: (number) => void;
  previous?: (number) => void;
};

type InitialData = {
  page?: number;
  per?: number;
};

const usePagination = (initial?: InitialData) => {
  const [page, setPage] = useQueryParam("page", String(initial?.page ?? 1));

  const [per, setPer] = useState(initial?.per ?? 10);

  const next = () => setPage(String(Number(page) + 1));
  const previous = () => setPage(String(Number(page) - 1));

  return {
    page: Number(page),
    per,
    setPage,
    setPer,
    next,
    previous,
  } as PaginationData;
};

export default usePagination;
